<template>
    <div class="fake-checkbox-container">
        <div class="fake-checkbox position-relative">
            <div
                ref="fakecheckbox"
                v-on:click="engage"
                v-model="checked"
                class="position-relative"
                style="width: 18px; height: 18px; padding: 2px"
            >
                <svg v-if="popUp" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 16 16" style="display: none;"><path fill="#000" d="M 6 14.023438 L 0 8.265625 L 1.859375 6.351562 L 5.964844 10.265625 L 14.105469 1.976562 L 16 3.855469 Z M 6 14.023438"/></svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 16 16" style="display: none;"><path fill="#000" d="M 6 14.023438 L 0 8.265625 L 1.859375 6.351562 L 5.964844 10.265625 L 14.105469 1.976562 L 16 3.855469 Z M 6 14.023438"/></svg>
            </div>
            <label for="">
                <input
                    :id="'faked-checkbox-' + id"
                    class="faked"
                    type="checkbox"
                    ref="realcheckbox"
                    :checked="!!checked"
                    :name="name"
                    :required="!!required"
                    v-on:change="engage"
                    aria-labelledby="faked-checkbox"
                    aria-label="required"
                />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    mounted: function () {
        this.checked = this.check;
        this.selector = $(this.$refs.fakecheckbox);
        this.target = $(this.$refs.realcheckbox);
        this.toggleCheckbox();
    },
    props: {
        id: {
            type: Number,
            default: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000,
        },
        check: {
            type: Boolean,
        },
        required: {
            type: Boolean,
            default: true,
        },
        popUp: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: null,
        },
        validationMessage: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            selector: false,
            target: false,
            checked: false,
        };
    },
    methods: {
        flipState() {
            this.checked = !this.checked;
            return this;
        },
        toggleCheckbox() {
            if (this.checked === true) {
                this.tickOn();
                this.targetTickOn();
            } else {
                this.tickOff();
                this.targetTickOff();
            }
        },
        engage(event) {
            event.stopPropagation();

            this.flipState().toggleCheckbox();
        },
        tickOn() {
            $(this.selector).find('svg').css("display", "block");
        },
        tickOff() {
            $(this.selector).find('svg').css("display", "none");
        },
        targetTickOn() {
            $(this.target).prop('checked', true);
        },
        targetTickOff() {
            $(this.target).prop('checked', false);
        },
        setValidationMessage(event) {
            event.target.validity.valueMissing
                ? event.target.setCustomValidity(this.validationMessage)
                : event.target.setCustomValidity('');
        },
    },
};
</script>
